module.exports = __webpack_public_path__ + "landing-bg-new.1117d7f2b5b280a4b85f.png";


//////////////////
// WEBPACK FOOTER
// C:/Users/Lenovo/Desktop/bigadvicefirestore/src/assets/images/landing-bg-new.png
// module id = ../../../../../src/assets/images/landing-bg-new.png
// module chunks = main